import { LayoutState, LayoutStyles, layouts } from '@core/types';
import { useEffect, useLayoutEffect, useRef, useState } from 'react';
import { useMobileMenu } from './useMobileMenu';

const SWITCH_TO_MENU_WIDTH = 800;

export const useLayout = () => {
    const mainContainerRef = useRef<HTMLDivElement>(null);
    const [width, setWidth] = useState<number>(mainContainerRef?.current?.clientWidth || 0);
    //const [containerHeight, setContainerHeight] = useState<number>(mainContainerRef?.current?.clientHeight || 0);
    const dimensions = mainContainerRef?.current?.getBoundingClientRect();
    const isMobileView = width < SWITCH_TO_MENU_WIDTH;
    const [mobileMenuEnabled, setMobileMenuEnabled] = useState<boolean>(false);
    const [isLandscape, setIsLandscape] = useState<boolean>(false);
    const [usedLayout, setUsedLayout] = useState<LayoutState>(layouts.initLayoutState);
    const [gridContentStyles, setGridContentStyles] = useState<LayoutStyles | undefined>(usedLayout.styles);
    const [pollsActive, setPollsActive] = useState<boolean>(false);
    const {
        chapterMobileMenuActive,
        chatMobileMenuActive,
        slidesMobileMenuActive,
        participantsMobileMenuActive,
        pollsMobileMenuActive,
        videoMobileMenuActive,
        onMobileMenuItemClicked
    } = useMobileMenu();
    const [videoActivated, setVideoActived] = useState<boolean>(mobileMenuEnabled ? videoMobileMenuActive : true);
    const [pollsActivated, setPollsActivated] = useState<boolean>(mobileMenuEnabled ? chapterMobileMenuActive : usedLayout.pollsActive);
    const [chapterActivated, setChapterActivated] = useState<boolean>(mobileMenuEnabled ? chapterMobileMenuActive : usedLayout.chapterActive);
    const [chatActivated, setChatActivated] = useState<boolean>(mobileMenuEnabled ? chatMobileMenuActive : usedLayout.chatActive);
    const [slidesActivated, setSlidesActivated] = useState<boolean>(mobileMenuEnabled ? slidesMobileMenuActive : usedLayout.slidesActive);
    const [participantsActivated, setParticipantsActivated] = useState<boolean>(mobileMenuEnabled ? slidesMobileMenuActive : usedLayout.participantsActive);

    useEffect(() => {
        let lastWidth = 0;
        const handle = setInterval(() => {
            if (!mainContainerRef.current) {
                return;
            }

            if (lastWidth === mainContainerRef.current.clientWidth) {
                return;
            }

            setWidth(mainContainerRef.current.clientWidth);
        }, 100);
        return () => clearInterval(handle);
    }, []);

    useLayoutEffect(() => {
        setIsLandscape(globalThis.window.matchMedia('(orientation: landscape)').matches);
    }, [dimensions]);

    useEffect(() => {
        setMobileMenuEnabled(isMobileView ? true : false);
        setPollsActive(isMobileView ? true : false);
    }, [width]);

    useEffect(() => {
        setSlidesActivated(mobileMenuEnabled ? slidesMobileMenuActive : usedLayout.slidesActive);
        setChapterActivated(mobileMenuEnabled ? chapterMobileMenuActive : usedLayout.chapterActive);
        setChatActivated(mobileMenuEnabled ? chatMobileMenuActive : usedLayout.chatActive);
        setParticipantsActivated(mobileMenuEnabled ? participantsMobileMenuActive : usedLayout.participantsActive);
        setPollsActivated(mobileMenuEnabled ? pollsMobileMenuActive : usedLayout.pollsActive);
        setVideoActived(mobileMenuEnabled && isLandscape ? videoMobileMenuActive : true);
    }, [
        mobileMenuEnabled,
        isLandscape,
        usedLayout,
        chapterMobileMenuActive,
        chatMobileMenuActive,
        slidesMobileMenuActive,
        participantsMobileMenuActive,
        pollsMobileMenuActive,
        videoMobileMenuActive
    ]);

    return {
        mainContainerRef,
        chapterActivated,
        chatActivated,
        slidesActivated,
        participantsActivated,
        pollsActivated,
        videoActivated,
        onMobileMenuItemClicked,
        pollsActive,
        gridContentStyles,
        mobileMenuEnabled,
        usedLayout,
        isLandscape
    };
};
